import axios from "axios";
import { probe, markOnline } from "@/lib/connectivity";
import { BACKEND } from "@/lib/host";

export const TOKEN_KEY = "samrtin_token";
export const ADMIN_TOKEN_KEY = "samrtin_admin_token";
export const BRANCH_KEY = "samrtin_branch";
// "Log in as" (super admin): tab-scoped token in sessionStorage, never cached for offline use.
export const IMP_KEY = "samrtin_imp_token";
const IMP_BRANCH = "samrtin_imp_branch";
export const impToken = () => sessionStorage.getItem(IMP_KEY);
export const getToken = () => impToken() || localStorage.getItem(TOKEN_KEY);
export const getBranch = () => (impToken() ? sessionStorage.getItem(IMP_BRANCH) : localStorage.getItem(BRANCH_KEY));
export const setBranch = (id) => (impToken() ? sessionStorage.setItem(IMP_BRANCH, id) : localStorage.setItem(BRANCH_KEY, id));
export function startImpersonation(token) {
  sessionStorage.setItem(IMP_KEY, token);
  sessionStorage.removeItem(IMP_BRANCH);
  window.location.assign("/pos");
}
export function exitImpersonation() {
  sessionStorage.removeItem(IMP_KEY);
  sessionStorage.removeItem(IMP_BRANCH);
  window.location.assign("/admin");
}
const baseURL = `${BACKEND}/api`;

export const api = axios.create({ baseURL });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  const b = getBranch();
  if (b && !cfg.headers["X-Branch-Id"]) cfg.headers["X-Branch-Id"] = b;
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    markOnline();
    return r;
  },
  (e) => {
    if (!e?.response) probe();
    else markOnline();
    const st = e?.response?.status;
    const code = e?.response?.data?.code;
    const url = e?.config?.url || "";
    if (st === 402 && code === "DEMO_EXPIRED") window.dispatchEvent(new Event("demo-expired"));
    if (st === 403 && code === "BRANCH_FORBIDDEN") {
      localStorage.removeItem(BRANCH_KEY);
      window.dispatchEvent(new Event("session-stale"));
    }
    if (st === 403 && code === "PERMISSION_DENIED") window.dispatchEvent(new Event("session-stale"));
    if (st === 401 && !url.includes("/auth/login")) window.dispatchEvent(new Event("session-stale"));
    return Promise.reject(e);
  }
);

export const adminApi = axios.create({ baseURL: `${baseURL}/admin` });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}
